// extracted by mini-css-extract-plugin
export var buttonLink = "codeOt-module--buttonLink--d88c0";
export var card = "codeOt-module--card--ac990";
export var description = "codeOt-module--description--0d888";
export var header = "codeOt-module--header--7a552";
export var image = "codeOt-module--image--f8caf";
export var line = "codeOt-module--line--8026e";
export var pictosPartners = "codeOt-module--pictosPartners--e11ed";
export var title = "codeOt-module--title--60cb6";
export var wrapper = "codeOt-module--wrapper--42c80";